import { useMutation } from "@apollo/client";
import { REGENERATE_AI_SUMMARY } from "graphql/mutations";

/**
 * useProfileRegenerateAiSummary
 *
 */
export default function useProfileRegenerateAiSummary() {
  const [regenerateSummary, { loading }] = useMutation(REGENERATE_AI_SUMMARY);

  const handleRegenerateProfileAiSummary = (profileId, onCompleted) => {
    regenerateSummary({
      variables: {
        input: {
          profileId,
        },
      },
      onCompleted: (data) => {
        if (typeof onCompleted === "function") {
          onCompleted(data?.regenerateProfileAiSummary?.profile?.aiSummaryUuid);
        }
      },
    });
  };

  return {
    handleRegenerateProfileAiSummary,
    loading,
  };
}
